import _ from "lodash";
import {UsersIcon} from "lucide-react"
import ScrollArea from 'react-scrollbar'

import { User } from "./user";
import {useSellerApp} from "../../../../store/service-activation/useSellerApp";

export function UserList(){
  const users = useSellerApp(st=>st.data.users)

  return(
    <div className="flex flex-col gap-4 w-full p-4 bg-white rounded border border-zinc-200/40 shadow">
      <div className="flex flex-col gap-6 px-2 ">
        <h1 className="flex gap-4 items-center justify-start">
          <UsersIcon className="w-6 h-6 text-scale-600" />
          <span className="text-lg font-semibold text-scale-600">Usuários</span>
        </h1>
      </div>
      <div className="flex flex-col max-h-72 h-fit gap-6">
        <ScrollArea smoothScrolling horizontal={false} className="w-full h-full pr-2">
          <div className="flex flex-col gap-2 group h-full w-full">
            {Object.entries(users).map(([key]) => <User key={key} userKey={key} />)}
            {!_.size(users) && (
              <div className="flex flex-col w-full items-center justify-center p-1 gap-2">
                <p className="text-center w-full">Para ativar o aplicativo do vendedor na sua unidade, baixe o app <strong className="font-bold">“PETLAND VENDAS PRO”</strong> na <strong className="font-bold">Play Store</strong> e cadastre um usuário com um número de telefone válido, que será usado para validar o acesso.</p>
                <p className="text-center w-full">Você receberá um <strong className="font-bold">SMS</strong> com o código de confirmação, e esse código também será exibido aqui na tela para você inserir no app.</p>
              </div>
            )}
          </div>
        </ScrollArea>
      </div>
    </div>
  )
}
